import React from 'react';
import { FlexyInput } from '@europrocurement/flexy-components';
import { Controller, FieldValues, UseFormReturn } from 'react-hook-form';
import { formatPrice } from '@europrocurement/l2d-utils';
import { Box, Typography } from '@mui/material';
import TextField from '../../components/form/TextField';
import { ArticleFormPricingState } from '../Form/types';
import { ArticlesSchema, ArticleAdditionalInformations } from '../Form/validation';

type ComponentProps = {
    articlePath: string;
    context: UseFormReturn<FieldValues, unknown>;
    article: ArticlesSchema['articles'][number] & ArticleAdditionalInformations;
    isOptionForm?: boolean;
    articlePricingInformations: ArticleFormPricingState;
};

const ArticlePriceLine: React.FunctionComponent<ComponentProps> = function ({
    articlePath,
    context,
    article,
    articlePricingInformations,
}) {
    const getInputName = (key: string) => `${articlePath}.${key}`;

    const originalPrice = article.originalArticle?.prixUnitaire;
    const { isFlatRate, flatPrice } = articlePricingInformations;
    const {
        formState: { errors },
        control,
    } = context;

    const pricePlaceholder = () => {
        if (originalPrice) {
            return `${formatPrice(originalPrice)} €`;
        }
        return 'Aucun prix défini';
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: '4px' }}>
            {isFlatRate && (
                <FlexyInput
                    sx={{ width: '100%', display: 'flex', gap: '4px' }}
                    disabled
                    value={flatPrice}
                    inputlabel="Tarif (au forfait)"
                    size="small"
                    type="text"
                    variant="outlined"
                    name=""
                />
            )}

            {!isFlatRate && (
                <Controller
                    name={getInputName('price')}
                    control={control}
                    render={({ field }) => (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '4px',
                            }}
                        >
                            <Typography
                                sx={{ color: 'text.gis70' }}
                                fontSize={15}
                                fontStyle="italic"
                            >
                                Tarif
                            </Typography>
                            <TextField
                                sx={{
                                    width: '100%',
                                }}
                                {...field}
                                name={field.name}
                                placeholder={pricePlaceholder()}
                                label=""
                                errors={errors}
                                required={false}
                            />
                        </Box>
                    )}
                />
            )}
        </Box>
    );
};

export default ArticlePriceLine;
